document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".estimated-delivery").forEach(function (root) {
    const inputCard = root.querySelector(".delivery-input-card");
    const resultCard = root.querySelector(".delivery-result-card");
    const form = root.querySelector(".delivery-input-wrapper");
    const input = root.querySelector(".pincode-eta-input");
    const button = root.querySelector(".estimated-delivery-button");
    const resultBox = root.querySelector(".delivery-result");
    const pincodeDisplay = root.querySelector(".delivery-pincode-display");
    const updateBtn = root.querySelector(".update-location");

    const jsonUrl = form.dataset.express;
    let pincodeData = [];

    const savedPincode = localStorage.getItem("userPincode");

    fetch(jsonUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        pincodeData = data;
        if (savedPincode) {
          input.value = savedPincode;
          checkPincode();
        }
      });

    function checkPincode() {
      const pincode = input.value.trim();

      if (!pincode) {
        resultBox.innerHTML = "Please enter a pincode";
        pincodeDisplay.textContent = "";
        inputCard.style.display = "none";
        resultCard.style.display = "flex";
        return;
      }

      const match = pincodeData.find(function (item) {
        return Number(item.P) === Number(pincode);
      });

      if (!match) {
        resultBox.innerHTML = "Delivery not available for this pincode";
        pincodeDisplay.textContent = pincode;
        inputCard.style.display = "none";
        resultCard.style.display = "flex";
        return;
      }

      const today = new Date();
      today.setDate(today.getDate() + match.T);

      const deliveryDate = today.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric"
      });

      resultBox.innerHTML = "Delivery by <strong>" + deliveryDate + "</strong>";
      pincodeDisplay.textContent = pincode;
      inputCard.style.display = "none";
      resultCard.style.display = "flex";

      localStorage.setItem("userPincode", pincode);
    }

    button.addEventListener("click", checkPincode);

    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        checkPincode();
      }
    });

    updateBtn.addEventListener("click", function () {
      inputCard.style.display = "flex";
      resultCard.style.display = "none";
    });

  });
});
